import { ref } from 'vue'

const isPauseCampaignOpen = ref(false)
const isChangeCampaignOpen = ref(false)
const isUpdateConnectivityProviderOpen = ref(false)
const isResumeCampaignOpen = ref(false)
const isEditingResumeDate = ref(false)

export function useRateConnect() {
  const togglePauseCampaign = (action, isEditing = false) => {
    if (action === 'open') {
      isPauseCampaignOpen.value = true
      isEditingResumeDate.value = isEditing
    }
    if (action === 'close') {
      isPauseCampaignOpen.value = false
      isEditingResumeDate.value = false
    }
  }

  const openChangeCampaignModal = () => {
    isChangeCampaignOpen.value = true
  }

  const closeChangeCampaignModal = () => {
    isChangeCampaignOpen.value = false
  }

  const openUpdateConnectivityProviderModal = () => {
    isUpdateConnectivityProviderOpen.value = true
  }

  const closeUpdateConnectivityProviderModal = () => {
    isUpdateConnectivityProviderOpen.value = false
  }

  const toggleResumeCampaign = action => {
    if (action === 'open') {
      isResumeCampaignOpen.value = true
    }
    if (action === 'close') {
      isResumeCampaignOpen.value = false
    }
  }
  return {
    isPauseCampaignOpen,
    isChangeCampaignOpen,
    isUpdateConnectivityProviderOpen,
    isResumeCampaignOpen,
    isEditingResumeDate,
    toggleResumeCampaign,
    togglePauseCampaign,
    openChangeCampaignModal,
    closeChangeCampaignModal,
    openUpdateConnectivityProviderModal,
    closeUpdateConnectivityProviderModal,
  }
}
